import "./App.css";
import {
  Route,
  Routes,
  useNavigate,
  useLocation,
  Navigate,
} from "react-router-dom";
import { useState } from "react";

import loadingGif from "./imgs/loading-state.gif";

/*IMPORTS DO ADMIN*/
import {
  Login,
  Manifestacao,
  ManifestacoesByStatus,
  SignupOuvidoria,
  MailBox,
  ByTipos,
  CategoriasOuvidorias,
  UsersOuvidoria,
  AdminHome,
  MailBoxTodas,
} from "./views/Admin/index.js";

/*IMPORTS DO USUARIO*/
import { Tipos } from "./views/Tipos";
import { Home } from "./views/Home";
import { OuvidoriaForm } from "./views/OuvidoriaForm";
import { TrackingOuvidoria } from "./views/TrackingOuvidoria";
import { TrackOuvidoria } from "./views/TrackOuvidoria";

// import Dashboards from "./views/Admin/Dashboards.js";

import { Navbar, Footer } from "./components/index.js";
import { RelatorioManifestacoes } from "./views/Admin/RelatorioManifestacoes.js";

function App() {
  const [message, setMessage] = useState(null);
  const [loading, setLoading] = useState(true);

  // const [error, setError] = useState(null);

  const userToken = localStorage.getItem("token");
  // const userId = localStorage.getItem("userId");

  const [loggedIn, setLoggedIn] = useState(!!userToken);

  const navigate = useNavigate();

  const handleLogin = (username) => {
    setLoggedIn(true);
    navigate("/admin/home");
  };

  const { pathname } = useLocation();
  const newLocation = pathname.split("/");

  const newPathname = pathname.slice(0, 6);

  return (
    <div>
      <>
        {newLocation[2] !== "login" && newLocation[2] !== "signup" ? (
          newLocation[1] !== "admin" ? (
            <Navbar />
          ) : null
        ) : null}
      </>

      <Routes>
        <Route
          path="/"
          element={
            <Home
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />

        <Route
          path="/add-complaint/:category"
          element={
            <OuvidoriaForm
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        <Route
          path="/acompanhamento/"
          element={
            <TrackOuvidoria
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        <Route
          path="/acompanhamento/:protocolo_id/:pass_protocolo"
          element={
            <TrackingOuvidoria
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        <Route
          path="/admin/login"
          element={
            <Login
              handleLogin={handleLogin}
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        <Route
          path="/admin/signup"
          element={
            <SignupOuvidoria
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        <Route
          path="/tipos/:tipo"
          element={
            <OuvidoriaForm
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        <Route
          path="/tipos"
          element={
            <Tipos
              message={message}
              setMessage={setMessage}
              loading={loading}
              setLoading={setLoading}
              loadingGif={loadingGif}
            />
          }
        />
        {newPathname === "/admin" && (
          <>
            <Route
              path="/admin/*"
              element={
                loggedIn ? (
                  <AdminHome
                    message={message}
                    setMessage={setMessage}
                    loading={loading}
                    setLoading={setLoading}
                    loadingGif={loadingGif}
                  />
                ) : (
                  <Navigate to="/admin/login" />
                )
              }
            />
            <Route
              path="/admin/home"
              element={
                <AdminHome
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/"
              element={
                <AdminHome
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/mailbox"
              element={
                <MailBox
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/manifestacoes/"
              element={
                <ByTipos
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/status/:status"
              element={
                <ManifestacoesByStatus
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/relatorios"
              element={
                <RelatorioManifestacoes
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/mailbox/status/:status"
              element={
                <ManifestacoesByStatus
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/mailbox/todas"
              element={
                <MailBoxTodas
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/tipo/:categoria/"
              element={
                <CategoriasOuvidorias
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/ouvidoria/:id"
              element={
                <Manifestacao
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
            <Route
              path="/admin/users/"
              element={
                <UsersOuvidoria
                  message={message}
                  setMessage={setMessage}
                  loading={loading}
                  setLoading={setLoading}
                  loadingGif={loadingGif}
                />
              }
            />
          </>
        )}
      </Routes>

      {newLocation[2] !== "login" && newLocation[2] !== "signup" ? (
        <Footer />
      ) : null}
    </div>
  );
}

export default App;
